import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { TanggalMerahPage } from "@/components/pages/TanggalMerahPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";

export const Route = createFileRoute("/en/red-dates/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).map((h) => ({
          name: h.name, date: h.date,
          description: h.type === "libur" ? `Public holiday ${y}.` : `Joint leave ${y}.`,
          url: `/en/red-dates/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Indonesia Red Dates ${y} - Public Holidays & Joint Leave` },
        { name: "description", content: `All ${y} red dates in Indonesia: public holidays, joint leave (cuti bersama), and Sundays.` },
        { property: "og:title", content: `Red Dates Indonesia ${y}` },
        { property: "og:description", content: `All red dates in Indonesia ${y}.` },
      ],
      links: [{ rel: "canonical", href: `https://hari.co.id/en/red-dates/${y}/` }],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Home", url: "/en" },
          { name: `${y}`, url: `/en/${y}` },
          { name: `Red Dates ${y}`, url: `/en/red-dates/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "en") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: () => {
    const { y } = Route.useLoaderData();
    return <TanggalMerahPage y={y} locale="en" />;
  },
  notFoundComponent: () => (
    <SiteShell locale="en"><div className="py-16 text-center"><h1 className="text-2xl font-bold">Invalid year</h1></div></SiteShell>
  ),
});